import { Font, pdf } from "@react-pdf/renderer";
import NotoSans from "../../assets/fonts/NotoSans-Regular.ttf";
import NotoSansBold from "../../assets/fonts/NotoSans-Bold.ttf";
import NotoSansMedium from "../../assets/fonts/NotoSans-Medium.ttf";
import NotoSansSemiBold from "../../assets/fonts/NotoSans-Medium.ttf";
import CustomPDF from "../../CustomPDF";
import { useEffect, useRef, useState } from "react";
import FileSaver from "file-saver";
import { useApp } from "../../../hook/check-app";
import { diseaseAPI } from "../../../apis";
import { fetchScoresAndVikriti } from "../../../apis/apicall";
import {
  processRisks,
  processScores,
  processVikriti,
  updateState,
} from "../../utils/helpers";

Font.register({
  family: "NotoSans",
  fonts: [
    { src: NotoSans },
    { src: NotoSansBold, fontWeight: "bold" },
    { src: NotoSansMedium, fontWeight: "medium" },
    { src: NotoSansSemiBold, fontWeight: "semiBold" },
  ],
  format: "truetype",
});

const Entry = () => {
  const {
    email: id,
    canDownloadPdf,
    canUploadPdfonCloud,
    currentUser,
    setCanUploadPdfonCloud,
    setCanDownlaodPdf,
  } = useApp();
  const [diseaseReports, setdiseaseReports] = useState(null);
  const [scores, setscores] = useState(null);
  const [firstPageScore, setFirstPageScore] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const initialLoadDiseae = useRef(true);

  useEffect(() => {
    if (id && id.length > 0 && userId.length === 0) {
      setUserId(id);
    }
  }, [id]);

  useEffect(() => {
    if (initialLoadDiseae.current) {
      initialLoadDiseae.current = false;

      const fetchApi = async () => {
        try {
          // fetch api ✅

          const [disease, scoreRes, vikritiRes] = await fetchScoresAndVikriti(
            id
          );

          // 1. Handle the diseases data ✅
          const { riskError, processedDisease, namefromRisk } =
            processRisks(disease);

          setError1(riskError);
          setdiseaseReports({ risks: processedDisease });

          // 2. Check Vikriti has data or not (return true/false) ✅
          const showVikriti = processVikriti(vikritiRes);

          // 3. Process the API result for score with vikriti ✅
          const { scoresWithRecommendations, name } = processScores(
            scoreRes,
            showVikriti,
            vikritiRes
          );
          console.log(
            "pdf-fetchApi: processScores - scoresWithRecommendations:",
            scoresWithRecommendations,
            "name:",
            name
          );
          
          
          // 3. Handle the user name  ✅
          if (namefromRisk.length > 0) {
            setUserName(namefromRisk);
          } else if (name.length > 0) {
            setUserName(name);
          } else {
            setUserName("Patron");
          }

          // 4. Handle the scores data

          const { recommendation, firstPageScore, error } = updateState(
            scoresWithRecommendations,
            showVikriti
          );

          setscores({ recommendations: recommendation });

          // 5. Handle the first page data
          console.log("PDF-firstPageScore-0", firstPageScore);

          handleError(error);
          setFirstPageScore(firstPageScore);
        } catch (error) {
          handleError(error);
        }
      };

      const handleError = (error) => {
        if (error) {
          setError2(error);
        }
      };

      const callPdf = async () => {
        await fetchApi();
        setLoading(false);
      };

      if (canDownloadPdf) {
        callPdf();
      }
    }
  }, [canDownloadPdf]);

  useEffect(() => {
    if (!loading && canDownloadPdf && firstPageScore.length > 0) {
      downloadPDF();
      setCanDownlaodPdf(false);
    }
  }, [loading, canDownloadPdf, firstPageScore]);

  const downloadPDF = async () => {
    try {
      // Generate the PDF blob

      const blob = await pdf(
        <CustomPDF
          diseaseReports={diseaseReports}
          scores={scores}
          error1={error1}
          error2={error2}
          firstPageScore={firstPageScore}
          userName={userName}
          id={userId}
        />
      ).toBlob();

      // Save the PDF locally if needed
      if (!(canDownloadPdf && canUploadPdfonCloud))
        FileSaver.saveAs(blob, "report.pdf");

      if (canUploadPdfonCloud) {
        // Convert the blob to a base64 string (keep the full data URL, including MIME type)
        const base64Blob = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); // Get the full base64 data URL
          reader.onloadend = () => resolve(reader.result); // Keep the entire data URL
          reader.onerror = reject;
        });

        // Strip the `data:application/pdf;base64,` prefix from the base64 string
        const base64Content = base64Blob.split(",")[1]; // Only take the base64 part

        console.log("base64Blob:", base64Blob);
        console.log("base64Content:", base64Content);

        // Send the base64 string to the API
        const payload = {
          client: "madmachines",
          user_id: id, // Changed to match the passed userId prop
          pdf_blob: base64Content, // Use the base64 content without the prefix
        };
        const response = await diseaseAPI.savePdf(payload);
        console.log("response:", response);
        console.log("PDF uploaded successfully");
        setCanUploadPdfonCloud(false);
      }
    } catch (error) {
      console.error("Error generating or uploading PDF:", error);
      throw new Error(error.message);
    }
  };

  return <></>;
};

export default Entry;
